import { searchModels, createModel, updateModel, deleteModel, restoreModel, getModel, getRevisions, duplicateModel, replaceTags } from '../../../../redux/DefaultModelActions';
import { APIBase, APIPost } from '../../../../services/API';

const model = 'Person';
const route = '/v1/person';

export const searchPeople = (page, limit, search, view, args) => searchModels(model, route, page, limit, search, view, args);
export const createPerson = (args) => createModel(model, route, args);
export const updatePerson = (id, args) => updateModel(model, route, id, args);
export const deletePerson = (id) => deleteModel(model, route, id);
export const restorePerson = (id) => restoreModel(model, route, id);
export const getPerson = (id) => getModel(model, route, id);
export const getPersonRevision = (id) => getRevisions(model, route, id);
export const duplicatePerson = (id) => duplicateModel(model, route, id);

// Tagging
export const replacePeopleTags = (terms, contentType, contentId) => replaceTags(model, route, terms, contentType, contentId);

export const addPeopleTags = async (modelType, modelId, terms) => {

    try {
        const res = await APIPost(`${APIBase}${route}/tag`, { modelType, modelId, terms })
        const json = await res.json();
        return json;
    } catch (error) {
        return error;
    }

}